import { render } from "./StatisticsPortalFilter.vue?vue&type=template&id=e408d8b6&ts=true"
import script from "./StatisticsPortalFilter.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__